import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useAuth } from './Auth/AuthProvider';
import { LessonMap } from './LessonMap';
import { LandingPage } from './Landing';
export function HomePage() {
    const { session, isPending } = useAuth();
    if (isPending) {
        return _jsx("div", { style: { textAlign: 'center', padding: '2rem', color: '#808090' }, children: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430..." });
    }
    return session ? _jsx(LessonMap, {}) : _jsx(LandingPage, {});
}
